export class EligibilityIndicatorFilter {
    public IncludeInactive?: boolean;
}

export default EligibilityIndicatorFilter;